<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="parentFormGroup" class="bank-data-component">
  <div formArrayName="bank_accounts">
    <div
      class="row single-bank-data"
      [ngClass]="{
        'with-separator': extended && !single && I != parentFormGroup.get('bank_accounts')?.controls.length - 1
      }"
      *ngFor="let singleBankAcc of parentFormGroup.get('bank_accounts')?.controls; let I = index"
      [formGroupName]="I"
    >
      <div class="col" [ngClass]="{ 'custom-col': extended }">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label *ngIf="I == 0 || extended">{{ 'BANK_ACCOUNTS_COMPONENT.BANK_NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="name" />
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label *ngIf="I == 0 || extended">{{ 'BANK_ACCOUNTS_COMPONENT.IBAN' | translate }}</label>
              <input type="text" class="form-control" formControlName="iban" />
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label *ngIf="I == 0 || extended">{{ 'BANK_ACCOUNTS_COMPONENT.BIC' | translate }}</label>
              <input type="text" class="form-control" formControlName="bic" />
            </div>
          </div>
        </div>
      </div>

      <div class="w-100" *ngIf="extended"></div>
      <div *ngIf="extended" class="col">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label *ngIf="I == 0 || extended">{{ 'BANK_ACCOUNTS_COMPONENT.ABBREVIATION' | translate }}</label>
              <input type="text" class="form-control" formControlName="abbreviation" />
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label *ngIf="I == 0 || extended">{{ 'BANK_ACCOUNTS_COMPONENT.BENEFICIARY_NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="beneficiary_name" />
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label *ngIf="I == 0 || extended">{{ 'BANK_ACCOUNTS_COMPONENT.ADDRESS' | translate }}</label>
              <input type="text" class="form-control" formControlName="address" />
            </div>
          </div>

          <div class="col">
            <app-currency-select
              [passFormControlName]="'currency_id'"
              [parentFormGroup]="singleBankAcc"
            ></app-currency-select>
          </div>

          <div class="col">
            <div class="form-group">
              <label *ngIf="I == 0 || extended">{{ 'BANK_ACCOUNTS_COMPONENT.SORT_CODE' | translate }}</label>
              <input type="text" class="form-control" formControlName="sort_code" />
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label *ngIf="I == 0 || extended">{{ 'BANK_ACCOUNTS_COMPONENT.ACCOUNT_NUMBER' | translate }}</label>
              <input type="text" class="form-control" formControlName="account_number" />
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-auto d-flex"
        *ngIf="parentFormGroup.get('bank_accounts').controls.length > 1 || (!required && !single)"
      >
        <button type="button" class="align-self-end remove" (click)="removeBankData(I)">
          <i class="fal fa-times"></i>
        </button>
      </div>
    </div>

    <div *ngIf="!single">
      <div>
        <button type="button" class="btn btn-xs btn-primary float-end mb-3 mt-2" (click)="addBankData()">
          {{ 'BANK_ACCOUNTS_COMPONENT.ADD' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
